import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import type { IOverdueFilter } from 'shared/stores/use-overdue-filters';
import { useOverdueFiltersStore } from 'shared/stores/use-overdue-filters';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { TransportLineFormSelect } from 'components/common/transport-line-form-select';
import { StatisticsDateRangePicker } from 'components/statistics/statistics-date-range-picker';
import styles from './overdue-filters.module.scss';

export const OverdueFilters = () => {
  const { t } = useTranslation();
  const { filters, setFilters } = useOverdueFiltersStore();

  const [form] = Form.useForm();

  const handleSuccess = () => {
    transformAndSetFilters(form, (next: Partial<IOverdueFilter> = {}) => setFilters({ ...next, type: filters.type }));
  };

  return (
    <Form form={form} name='overdue-filter' layout='horizontal' initialValues={filters} className={styles.form}>
      <StatisticsDateRangePicker
        handleSuccess={handleSuccess}
        presets={['last_month', 'last_2_months', 'last_3_months']}
        disabledMonths={3}
      />
      <TransportLineFormSelect
        name='transportLine'
        label={t('overdue:direction')}
        placeholder={t('overdue:all_directions')}
        rootClassName={styles.lineSelect}
        allowClear
        onChange={handleSuccess}
      />
    </Form>
  );
};
